import { createTypes, createAction } from "lib/action";

const LOAD_STRUCTURE = createTypes("structure", "load");
const SHOW_STRUCTURE = createTypes("structure", "show");
const CREATE_STRUCTURE = createTypes("structure", "create");
const UPDATE_STRUCTURE = createTypes("structure", "update");
const DELETE_STRUCTURE = createTypes("structure", "delete");
const IMPORT_STRUCTURE = createTypes("structure", "import");
const EXPORT_STRUCTURE = createTypes("structure", "export");

const loadStructures = {
  request: (params, token) =>
    createAction(LOAD_STRUCTURE.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_STRUCTURE.FAILURE, { err }),
};

const showStructure = {
  request: (id, token) => createAction(SHOW_STRUCTURE.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_STRUCTURE.FAILURE, { err }),
};

const createStructure = {
  request: (params, token) =>
    createAction(CREATE_STRUCTURE.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_STRUCTURE.FAILURE, { err }),
};

const updateStructure = {
  request: (params, id, token) =>
    createAction(UPDATE_STRUCTURE.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_STRUCTURE.FAILURE, { err }),
};

const deleteStructure = {
  request: (id, token) => createAction(DELETE_STRUCTURE.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_STRUCTURE.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_STRUCTURE.FAILURE, { err }),
};

const importStructure = {
  request: (file, company_id, token) =>
    createAction(IMPORT_STRUCTURE.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_STRUCTURE.FAILURE, { err }),
};

const exportStructure = {
  request: (token) => createAction(EXPORT_STRUCTURE.REQUEST, { token }),
  success: (data) => createAction(EXPORT_STRUCTURE.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_STRUCTURE.FAILURE, { err }),
};

export {
  loadStructures,
  showStructure,
  createStructure,
  updateStructure,
  deleteStructure,
  importStructure,
  exportStructure,
  LOAD_STRUCTURE,
  SHOW_STRUCTURE,
  CREATE_STRUCTURE,
  UPDATE_STRUCTURE,
  DELETE_STRUCTURE,
  IMPORT_STRUCTURE,
  EXPORT_STRUCTURE,
};
